import React from 'react';

import {IconInitials as IconInitialsType} from '../../../../utils/services/types';

import useStyles from './useStyles';

const IconInitials = ({icon, size}: {icon: IconInitialsType; size: number}) => {
    const styles = useStyles(icon, size);

    return (
        <div
            className={styles.wrapper}
            aria-hidden="true"
            data-testid="HP-Icon"
        >
            <p>{icon.initials.substring(0, 2).toUpperCase()}</p>
        </div>
    );
};

export default IconInitials;
